import React, {useState, useEffect} from "react";
import brands1 from "../assets/images/brands1.jpg";
import {Link} from "react-router-dom";
import logo from "../assets/images/logo.svg";
import MotevafaImg from "../assets/images/motevafa.jpg";
import Footer from "./Footer";
import TopNav from "./TopNav";

import sia from "../services/Api";
import LoaderView from "../tools/LoaderView";

const StatesArchive = () => {
    const [irStates, setIrStates] = useState([]);
    const [isLoading, setLoading] = useState(true);
    const [search, setSearch] = useState('');

    useEffect(() => {
        getData()
    }, []);

    const getData = async () => {
        setLoading(true)
        await sia
            .getDataFromServer("/state")
            .then((res) => {
                setIrStates(res.data);
                console.log(res);
            })
            .catch((err) => {
                console.log(err);
            });

        console.log(irStates)
        setLoading(false)
    }

    return (
        <>
            <header>
                <div className="pagewrapper slim1" id="header-slim">
                    <div className="container">
                        <TopNav/>
                    </div>
                </div>
            </header>
            <div className="clear"/>
            <div className="pagewrapper" id="center-search">
                <div className="container">
                    <form onSubmit={() => window.location.assign('/d-list?s=' + search)} action id="center-search-form"
                          method="get">
                        <input
                            type="text"
                            name="s"
                            placeholder="کد متوفی را جستجو کنید"
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="text radius50 box-sizing"
                        />
                        <input type="submit" value="جستجو" className="btn ease radius50"/>
                    </form>
                    {localStorage.getItem('token') != null ? <a className="link-btn ease box-sizing radius50" onClick={() => window.location.assign('/login')}>ورود و ثبت نام رایگان صفحه یادبود</a> : <a className="link-btn ease box-sizing radius50" onClick={() => window.location.assign('/add-motevafa')}>ثبت یادبود</a>}

                </div>
            </div>
            <div className="pagewrapper" id="motevafa-list">
                {isLoading ? <LoaderView/> : <div className="container">
                    <h2 className="main-title">انتخاب استان ها</h2>
                    <ul className="list-items">
                        {!isLoading && irStates.map((item) => (
                            <li key={item._id} className="item">
                                <Link
                                    className="ease box-sizing radius10"
                                    to={`state?enName=` + item.nameEn + '&name=' + item.name}
                                >
                                    {item.name + " " + "(" + item.deadCount + ")"}
                                    {/* {item.name + ": " + item.deadCount} */}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </div>}
            </div>
            <div className="clear"/>
            <Footer/>
        </>
    );
};

export default StatesArchive;
